import styled from '@emotion/styled'
import { ExtranetContainer, MediaQuery, useBreakpoint } from '@pharmac-extranet/shared'
import { PharmacButton } from '@pharmac/ui'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { ExtranetWrapper } from '../components/extranet/ExtranetWrapper'
import { useAuthenticationContext } from '../features/authentication/useAuthentication'
import { useCustomerContext } from '../features/customer/CustomerProvider'
import { useExtranetPath } from '../router/useExtranetPath'
import { UnauthorizedView } from './UnauthorizedView'
import { NotLoggedInView } from './not-logged-in/NotLoggedInView'

const HugeErrorCode = styled.div`
  font-size: 300px;
  font-family: var(--font-family-secondary);
  font-weight: 600;
  line-height: 300px;
  color: var(--color-primary);
  text-align: center;
  width: 100%;

  ${MediaQuery.maxTablet} {
    font-size: 150px;
    line-height: 180px;
  }
`

const NotFoundTitle = styled.div`
  font-family: var(--font-family-secondary);
  font-size: 43px;
  color: var(--color-primary);
  font-weight: 600;
  line-height: 80px;
  text-align: center;
  width: 100%;

  ${MediaQuery.maxTablet} {
    font-size: 22px;
    line-height: 26px;
    padding-bottom: 10px;
  }
`

const NotFoundMessage = styled.div`
  font-family: var(--font-family-primary);
  font-size: 26px;
  line-height: 33px;
  text-align: center;
  width: 100%;
  margin-bottom: 20px;

  ${MediaQuery.maxTablet} {
    font-size: 16px;
    line-height: 18px;
  }
`

export const NotFoundPageView = () => {
  const { user, isPharmacUser, hasInitialized: acHasInitialized } = useAuthenticationContext()
  const { customer, hasInitialized: ccHasInitialized, showModal } = useCustomerContext()
  const { t } = useTranslation(['common'])

  const navigate = useNavigate()
  const createPath = useExtranetPath()
  const { minDesktop } = useBreakpoint()

  const hasInitialized = acHasInitialized && ccHasInitialized

  console.log('NotFoundPage :: DEBUG :: ', {
    hasInitialized,
    user,
    isPharmacUser,
    customer,
    showModal,
  })

  if (hasInitialized && !showModal && !customer && !isPharmacUser) {
    if (user) {
      return <UnauthorizedView />
    }

    return <NotLoggedInView />
  }

  return (
    <div style={{ width: '100%', height: '100%', backgroundColor: 'var(--extranet-light-purple)' }}>
      <ExtranetWrapper>
        <ExtranetContainer justifyCenter>
          <ExtranetContainer
            alignCenter
            justifyCenter
            flexColumn
            style={{ width: minDesktop ? 525 : '100%' }}
          >
            <HugeErrorCode>404</HugeErrorCode>
            <NotFoundTitle>{t('notFoundPageTitle')}</NotFoundTitle>
            <NotFoundMessage>{t('notFoundPageMessage')}</NotFoundMessage>
            <PharmacButton
              style={{
                width: 'calc(100% - var(--spacing-medium))',
                maxWidth: minDesktop ? 525 : 515,
              }}
              onClick={() => navigate(createPath('root'))}
            >
              <span style={{ fontSize: 18 }}>Palaa etusivulle</span>
            </PharmacButton>
          </ExtranetContainer>
        </ExtranetContainer>
      </ExtranetWrapper>
    </div>
  )
}
